import ActionsMenu from "components/Editorial/ActionsMenu";
import ErrorItems from "components/Editorial/ActionsMenu/ErrorItems";
import fetch from "lib/fetch";
import PropTypes from "prop-types";
import React, { useState } from "react";
import refreshCSRFToken from "lib/refreshCSRFToken";
import {
  useCurrentUser,
  EDITOR_USER_TYPE
} from "lib/currentUser";

const MAX_RETRIES = 5;
const RETRY_DELAY = 1000; // 1 second

// TODO: deprecated by GraphQL editorial actions. All Editorial/ActionsMenu sub-components should be deleted
// after GraphQL editorial menu takes over
export function Loader({ actionsPath }) {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [menuItems, setMenuItems] = useState([]);
  const { user } = useCurrentUser();

  const userIsEditor = user.type === EDITOR_USER_TYPE;

  React.useEffect(() => {
    if (!userIsEditor) { return; }

    fetch(actionsPath, {
      retries: MAX_RETRIES,
      retryDelay: RETRY_DELAY,
    }).then(response => response.json())
      .then(data => setMenuItems(data))
      .then(refreshCSRFToken) // Editorial actions might require POST
      .catch(() => {
        setMenuItems(ErrorItems.render());
        setError(true);
      })
      .finally(() => setLoading(false));
  }, [actionsPath, userIsEditor]);

  if (!userIsEditor) { return <React.Fragment />; }

  return <ActionsMenu error={error} loading={loading} menuItems={menuItems} />;
}

Loader.propTypes = {
  actionsPath: PropTypes.string.isRequired,
};

export default Loader;
